module.exports = __webpack_public_path__ + "static/media/phone-conversation.55d0a353.jpg";